import React from 'react';
import {Range, getTrackBackground} from 'react-range';

const RangeInput = (props: RangeInputProps) => {
  const {max, min, onChange, value} = props;

  return (
    <Range
      draggableTrack
      max={max}
      min={min}
      onChange={onChange}
      values={value}
      renderThumb={({props, isDragged}) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: '42px',
            width: '42px',
            borderRadius: '4px',
            backgroundColor: '#FFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 2px 6px #AAA'
          }}
        >
          <div
            style={{
              height: '16px',
              width: '5px',
              backgroundColor: isDragged ? '#548BF4' : '#CCC'
            }}
          />
        </div>
      )}
      renderTrack={({props, children}) => (
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          style={{
            ...props.style,
            height: '36px',
            display: 'flex',
            width: '100%'
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: '5px',
              width: '100%',
              borderRadius: '4px',
              background: getTrackBackground({
                values: value,
                colors: ['#ccc', '#548BF4', '#ccc'],
                min: min,
                max: max
              }),
              alignSelf: 'center'
            }}
          >
            {children}
          </div>
        </div>
      )}
    />
  );
};

export default RangeInput;

type RangeInputProps = {
  max: number;
  min: number;
  onChange: (value: number[]) => void;
  value: number[];
};
